import { render } from "./HelloWorld.vue?vue&type=template&id=379548a4&scoped=true"
import script from "./HelloWorld.vue?vue&type=script&lang=js"
export * from "./HelloWorld.vue?vue&type=script&lang=js"

import "./HelloWorld.vue?vue&type=style&index=0&id=379548a4&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/.pnpm/vue-loader@17.0.1_vue@3.2.43+webpack@5.75.0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-379548a4"]])

export default __exports__